import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const BaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');

const themeRoutes: RouteRecordRaw[] = [{
    path: '/themes',
    component: BaseDashboard,
    meta: {
        title: 'Booking page style',
        icon: 'mdi-palette',
        noCache: false,
        hidden: true,
        permissions: ['settings_view'],
        middleware: ['auth'],
        layout: 'Dashboard',
    } as CommonRouteMeta,
    children: [
        {
            path: '',
            components: {
                default: () => import('@/views/themes/ThemeCustomize.vue'),
            },
            name: 'themes.index',
            meta: {title: 'Booking page style', icon: 'mdi-palette', noCache: false, isBase: true},
        },
    ],
}];

export default themeRoutes;
